import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./dailyPartFormEdit.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { converToTime } from "../../../../utils/formats/number";
// import InputSelect from "../../../utils/InputSelect";
import {
  ButtonRow,
  ContainerDaily,
  Label,
  Value,
  TitleSection,
  HeadListTask,
  EditButton,
  DeleteButton,
  ValueWithBack,
  ValueRow,
} from "./dailyPartFormEdit.styled";
import {
  InputDate,
  InputText,
  InputSelect,
  InputTextarea,
  BreadCrumb,
} from "@de-prado-dev/react-component-library";
import { PART_STATUS } from "../../../../constants/index";

const WorkingPartForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    onChangeCode,
    isManager,
    dailyPart,
    employee,
  } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit
              ? t("forms.workingPart.titleEdit")
              : t("forms.workingPart.titleNew")}
          </h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11">
          <ContainerDaily>
            <div className="column align-items-center">
              <div className="col-12 d-flex flex-row">
                <Label>{t("forms.workingPart.labels.user")}</Label>
                <Value>
                  {employee ? employee.name + " " + employee.surname : ""}
                </Value>
              </div>
              <div className="col-12 d-flex flex-row">
                <Label>{t("forms.workingPart.labels.currentDate")}</Label>
                <Value>
                  {dailyPart
                    ? moment(dailyPart?.date).format("DD-MM-yyyy")
                    : ""}
                </Value>
              </div>
            </div>
          </ContainerDaily>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="date"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.newDate")}
                  name="date"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd-MM-yyyy"
                  mandatory
                  defaultHours={15}
                  defaultMinutes={0}
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.workingPart.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.workingPart.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

WorkingPartForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  edit: PropTypes.bool,
};

const WorkingPartFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "WorkingPartForm",
})(WorkingPartForm);

export default WorkingPartFormF;
